module.exports = __webpack_public_path__ + "static/media/paso3.f6be599f.png";